import { useField } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFieldProps, FieldBase } from './FieldBase';

type CheckboxProps = {
  title?: string,
} & DefaultFieldProps;

export function CheckboxInput({ name, title, label, containerClassName, ...props }: CheckboxProps): JSX.Element {
  const { t } = useTranslation();
  const [field] = useField(name);
  const checked = field?.value || false;

  return (
    <FieldBase name={name} containerClassName={containerClassName}>
      <div className={`form-check-flex ${props.disabled ? 'disabled' : ''}`}>
        <input
          id={name}
          data-cy={`toggle-${name}`}
          className='form-check-input mt-1'
          type='checkbox'
          checked={checked}
          disabled={props.disabled}
          {...field}
        />

        <div>
          <label htmlFor={name}>
            {title && <div className='form-check-label'>{title}</div>}
            {!!label && (
              <span className='form-check form-check-label'>
                {label || t(`form.label.checkbox.${name}`)}
              </span>
            )}
          </label>
        </div>
      </div>
    </FieldBase>
  );
}
